/**
 * Product Accessories
 * Checkbox-selected add-on products, added to cart in one request.
 * Data source: product metafield (list of product references).
 */

(function () {
  function formatMoney(cents) {
    // GBP store — simple formatter
    return '£' + (cents / 100).toFixed(2);
  }

  function initSection(sectionEl) {
    if (!sectionEl || sectionEl.dataset.paInit) return;
    sectionEl.dataset.paInit = 'true';

    const cards = Array.from(sectionEl.querySelectorAll('[data-pa-card]'));
    const addBtn = sectionEl.querySelector('[data-pa-add]');
    const totalEl = sectionEl.querySelector('[data-pa-total]');
    const errorEl = sectionEl.querySelector('[data-pa-error]');
    if (!addBtn) return;

    function selectedItems() {
      const items = [];
      let total = 0;
      cards.forEach((card) => {
        const check = card.querySelector('[data-pa-check]');
        if (!check || !check.checked || check.disabled) return;
        const variantInput = card.querySelector('[data-pa-variant]');
        const qtyInput = card.querySelector('[data-pa-qty-input]');
        if (!variantInput) return;
        const id = parseInt(variantInput.value, 10);
        const quantity = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
        let price = 0;
        if (variantInput.tagName === 'SELECT') {
          const opt = variantInput.options[variantInput.selectedIndex];
          price = opt ? parseInt(opt.dataset.price || '0', 10) : 0;
        } else {
          const priceEl = card.querySelector('[data-pa-price]');
          price = priceEl ? parseInt(priceEl.dataset.price || '0', 10) : 0;
        }
        items.push({ id, quantity });
        total += price * quantity;
      });
      return { items, total };
    }

    function refreshButton() {
      const { items, total } = selectedItems();
      addBtn.disabled = items.length === 0;
      totalEl.textContent = items.length ? '· ' + formatMoney(total) : '';
    }

    cards.forEach((card) => {
      const check = card.querySelector('[data-pa-check]');
      const variantInput = card.querySelector('[data-pa-variant]');
      const priceEl = card.querySelector('[data-pa-price]');
      const qtyInput = card.querySelector('[data-pa-qty-input]');

      if (check) {
        check.addEventListener('change', () => {
          card.classList.toggle('is-selected', check.checked);
          refreshButton();
        });
      }

      if (variantInput && variantInput.tagName === 'SELECT') {
        variantInput.addEventListener('change', () => {
          const opt = variantInput.options[variantInput.selectedIndex];
          if (opt && priceEl) {
            priceEl.dataset.price = opt.dataset.price || '0';
            priceEl.textContent = formatMoney(parseInt(opt.dataset.price || '0', 10));
          }
          // Changing variant auto-selects the card
          if (check && !check.checked && !check.disabled) {
            check.checked = true;
            card.classList.add('is-selected');
          }
          refreshButton();
        });
      }

      const minus = card.querySelector('[data-pa-qty-minus]');
      const plus = card.querySelector('[data-pa-qty-plus]');
      if (minus && qtyInput) {
        minus.addEventListener('click', () => {
          qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
          refreshButton();
        });
      }
      if (plus && qtyInput) {
        plus.addEventListener('click', () => {
          qtyInput.value = Math.min(99, (parseInt(qtyInput.value, 10) || 1) + 1);
          refreshButton();
        });
      }
      if (qtyInput) {
        qtyInput.addEventListener('change', refreshButton);
      }
    });

    async function refreshAndOpenCart() {
      // Refresh Dawn/Craft cart drawer contents via section rendering
      try {
        const res = await fetch(window.location.pathname + '?section_id=cart-drawer');
        if (res.ok) {
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const newDrawer = doc.querySelector('cart-drawer');
          const currentDrawer = document.querySelector('cart-drawer');
          if (newDrawer && currentDrawer) {
            currentDrawer.innerHTML = newDrawer.innerHTML;
          }
        }
      } catch (e) {
        // non-fatal
      }

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
        return;
      }
      document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
      const cartIcon = document.querySelector('a[href="/cart"]');
      if (cartDrawer && cartIcon) {
        // Fallback: go to cart page if drawer cannot open
        window.location.href = '/cart';
      }
    }

    addBtn.addEventListener('click', async () => {
      const { items } = selectedItems();
      if (items.length === 0) return;

      addBtn.classList.add('is-loading');
      if (errorEl) errorEl.hidden = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });

        if (!res.ok) throw new Error('Cart add failed');
        await res.json();

        // Uncheck everything after success
        cards.forEach((card) => {
          const check = card.querySelector('[data-pa-check]');
          if (check) check.checked = false;
          card.classList.remove('is-selected');
        });
        refreshButton();

        await refreshAndOpenCart();
      } catch (e) {
        if (errorEl) errorEl.hidden = false;
      } finally {
        addBtn.classList.remove('is-loading');
      }
    });

    refreshButton();
  }

  function initAll() {
    document.querySelectorAll('[data-pa-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => {
      const el = e.target.querySelector
        ? e.target.querySelector('[data-pa-section]') || (e.target.matches('[data-pa-section]') ? e.target : null)
        : null;
      if (el) initSection(el);
    });
  }
})();
